import { Analytics } from '../../util/Analytics';
import { ActionType } from '../ActionTypes';
import { store, StoreAction } from '../Store';
import { dispatchDoctorUserData } from '../userData/UserDataActions';
import { EntryState } from './EntryState';

export type EntryAction = {
  type: ActionType.SET_ENTRY;
  entry: EntryState;
};

export function entryReducer(state: EntryState, action: StoreAction): EntryState {
  switch (action.type) {
    case ActionType.SET_ENTRY: {
      // Note SET_ENTRY is also handled in the pricing reducer, and for the coupon in the root reducer.
      return action.entry;
    }
    default:
      return state;
  }
}

/**
 * Puts the resolved Entry in the store. A confirmed referral answers the doctor question for the user,
 * as hydra-mobile patient reports read the doctor answer, and tracks `h_hcp_referred` as a Yes would.
 */
export function dispatchEntry(entry: EntryState): void {
  store.dispatch({ type: ActionType.SET_ENTRY, entry });
  if (entry.referral !== undefined) {
    Analytics.track({ event: Analytics.Event.h_hcp_referred });
    dispatchDoctorUserData({ referred: 'Yes' });
  }
}
